import { Component, OnInit, OnDestroy, Renderer2, SecurityContext, Inject } from '@angular/core';
import { BookingParametersInterface, codetype } from '../../../../../src/app/shared/entities/bookingParameters';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationService } from '../../../../../src/app/core/services/navigation.service';
import { AppColorService } from '../../../../../src/app/core/services/app-color.service';
import { DOCUMENT } from '@angular/common';
import { BookingParameterService } from '../../../../../src/app/core/services/booking-parameter.service';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnInit, OnDestroy {

  private routeSub: Subscription;
  lang: string;
  bookingParams: BookingParametersInterface = undefined;
  showLogo = true;
  referer = '';
  refererId: string;
  hidePromocode = false;
  maxAllowedChildren: number;
  maxAllowedPersons = 50;
  disableSearch = false;
  redirect = null;

  constructor(
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private bpService: BookingParameterService,
    private sanitizer: DomSanitizer,
    private navigationService: NavigationService,
    private colorService: AppColorService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit() {
    this.bookingParams = this.bpService.createNewBookingParameters();
    this.routeSub = this.route.queryParams.subscribe((params: Params) => {
      this.bookingParams.slug = params['slug'] ? params['slug'] : '';
      this.parseUrlParameters(params);
      if (params['ages[]']) {
        if (Array.isArray(params['ages[]'])) {
          this.bookingParams.ages = params['ages[]'];
        } else {
          this.bookingParams.ages = [params['ages[]']];
        }
      }
      this.bookingParams.codes = params['promocode'] ? [{ type: codetype.promo, text: params['promocode'] }] : null;
      this.lang = params['lang'];
    });
  }

  private parseUrlParameters(params: Params) {
    const colorParams = {};
    Object.keys(params).filter((check) => check.startsWith('--')).forEach((key) => {
      if (params[key]) {
        colorParams[this.sanitizer.sanitize(SecurityContext.STYLE, key)]
          = this.sanitizer.sanitize(SecurityContext.STYLE, decodeURIComponent(params[key]));
      }
    });
    if (params['background']) { // background-color
      const val = this.sanitizer.sanitize(SecurityContext.STYLE, decodeURIComponent(params['background']));
      colorParams['--primary-color'] = val;
      colorParams['--iframe-backg'] = val;
    }
    if (params['ifbackg']) {
      colorParams['--iframe-backg'] = this.sanitizer.sanitize(SecurityContext.STYLE, decodeURIComponent(params['ifbackg']));
    }
    if (params['buttonFont']) { // not font family, font color
      colorParams['--secondary-text-color'] = this.sanitizer.sanitize(SecurityContext.STYLE, decodeURIComponent(params['buttonFont']));
    }
    this.setCssColorVars(colorParams);
    if (params['partner']) {
      this.bookingParams.partner = 'partner-' + params['partner'].replace('partner-', '');
    }
    if (params['maxAllowedChildren']) {
      this.maxAllowedChildren = +params['maxAllowedChildren'];
    }

    if (params['maxAllowedPeople']) {
      this.maxAllowedPersons = +params['maxAllowedPeople'];
    }

    if (params['showLogo']) { // display logo, or not
      this.showLogo = +params['showLogo'] === 1;
    }
    if (params['refererUrl']) { // add this referer
      this.referer = params['refererUrl'];
    }
    if (params['refId']) { // ???
      this.refererId = params['refId'];
    }
    if (params['hidePromotionCodeField']) { // hide the promocode field if set
      this.hidePromocode = +params['hidePromotionCodeField'] === 1;
    }
    if (params['disableSearch']) {
      this.disableSearch = +params['disableSearch'] === 1 && this.bookingParams.slug !== '';
    }
    if (params['redirect']) {
      this.redirect = params['redirect'].trim();
    }
  }

  private async setCssColorVars(vars: { [key: string]: string }) {
    const variables = await this.colorService.getColorFor(vars);
    const root = this.document.documentElement;
    this.renderer.setAttribute(root, 'style', Object.keys(variables).map((v) => { return `${v}:${variables[v]}` }).join('; '));
    this.colorService.injectPartnerFonts('');
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }

  updateForm(event: BookingParametersInterface) {
    this.bookingParams = event;
    this.bpService.saveBookingParameters(this.bookingParams);
    const params = {} as any;

    if (this.redirect) {
      params.redirect = this.redirect;
    }

    if (this.referer) {
      params['referer'] = this.referer;
    }

    if (event.poi.type === 'AlpinShop') {
      this.navigationService.navigateToProductSelection(
        event.poi,
        this.bookingParams,
        params,
      );
    } else {
      params['startDate'] = this.dateToString(this.bookingParams.start);
      params['endDate'] = this.dateToString(this.bookingParams.end);
      params['personAges[]'] = this.bookingParams.ages;
      params['promotionCode'] = this.bookingParams.codes.filter(c => c.type === codetype.promo)[0]?.text;
      this.navigationService.navigateToPoi(
        event.poi,
        false,
        this.bookingParams.partner,
        true,
        params
      );
    }
  }

  private dateToString(date: Date): string {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
  }
}
